export const FETCHED_LANGUAGES = 'FETCHED_LANGUAGES';


// WEBPACK FOOTER //
// ./src/containers/languages/types.js